import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { PaymentInfoForm } from '@/modules/partner/model/form';
import { namespace } from '@/modules/partner/namespace';
import { getPartner } from '@/modules/partner/store/selectors';
import type { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';
import { ISubmitFormResult } from '@/shared/models/formSubmit';

import { updatePartner } from '../actions';

let lastRequestId: string | undefined;

const updatePaymentInfo = createAsyncThunk<
  ThunkResult<ISubmitFormResult<PaymentInfoForm>>,
  PaymentInfoForm
>(
  `${namespace}/submit-payment-info-step`,
  async (formValues, { dispatch, requestId, getState }) => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      const partner = getPartner(getState() as RootState);

      const result = await partnerAPI.updatePaymentInfo({
        ...partner,
        paymentAccount: formValues.accountNumber,
        paymentRoutingNumber: formValues.routingNumber,
        paymentSortCode: formValues.sortCode,
        paymentBik: formValues.bik,
        paymentIban: formValues.iban,
        paymentSwift: formValues.swift,
        paymentRasAccount: formValues.rasAccount,
        paymentBankName: formValues.bankName,
        paymentKorAccount: formValues.corAccount,
      });

      if (result.baseErrors) {
        return {
          isSucceed: false,
          result,
        };
      }

      dispatch(
        updatePartner({
          paymentAccount: formValues.accountNumber,
          paymentRoutingNumber: formValues.routingNumber,
          paymentSortCode: formValues.sortCode,
          paymentBik: formValues.bik,
          paymentIban: formValues.iban,
          paymentSwift: formValues.swift,
          paymentRasAccount: formValues.rasAccount,
          paymentBankName: formValues.bankName,
          paymentKorAccount: formValues.corAccount,
        }),
      );

      return {
        isSucceed: true,
        result,
      };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { updatePaymentInfo };
